import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
const myCustomTheme = {
    colors: {
        primary: '#1d9e8a',
        secondary: '#1d9e8a',
        accent: '#1d9e8a',
        success: '#3cd1c2',
        info: '#ffaa2c',
        error: '#f83e70',
    },

}
export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'myCustomTheme',
        themes: {
            myCustomTheme,
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
})